import { useChooseCampaignTakeover } from 'modules/experiments/hooks';
import { ChooseCampaignTakeoverProps } from 'modules/experiments/types';

import { ChooseCampaignDrawer } from './ChooseCampaignDrawer';

export const ChooseCampaignTakeover = ({ onClose }: ChooseCampaignTakeoverProps) => {
  const { isChooseCampaignTakeoverOpen } = useChooseCampaignTakeover();
  return isChooseCampaignTakeoverOpen && <ChooseCampaignDrawer onClose={onClose} />;
};
